import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import { StyleProvider } from "@ant-design/cssinjs";
import "./app/assets/scss/style.scss";
import { AppRoutes } from "./routes";

function App() {
  return (
    <StyleProvider hashPriority="high" layer>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: "'Plus Jakarta Sans', serif",
          },
          components: {
            Checkbox: {
              colorBgContainer: "#0b5167",
              colorBorder: "#0b5167",
            },
            Table: {
              rowHoverBg: "#F6F9F9",
              rowSelectedBg: "#E7F9F3",
              rowSelectedHoverBg: "#D0F2E8",
            },
          },
          hashed: false,
        }}
      >
        <div className="App">
          <Router>
            <AppRoutes />
          </Router>
        </div>
      </ConfigProvider>
    </StyleProvider>
  );
}

export default App;
